declare global {
  interface Window {
    __APP_CONFIG__?: { brand?: string; theme?: string };
  }
}

const w = window.__APP_CONFIG__ || {};

const brand = w.brand || process.env.REACT_APP_BRAND || 'bat';
const theme = w.theme || process.env.REACT_APP_THEME || `${brand}_light`;
const apiUrl = process.env.REACT_APP_API_URL || `${window.location.origin}/`;

export const config = {
  brand,
  theme,
  apiUrl,
  title: process.env.REACT_APP_TITLE || '',
  description: process.env.REACT_APP_DESCRIPTION || '',
  loginTitle: process.env.REACT_APP_LOGIN_TITLE || '',
  loginDescription: process.env.REACT_APP_LOGIN_DESCRIPTION || '',
  languages: process.env.REACT_APP_LANGUAGES || '["en"]',
  oldFrontLink: process.env.REACT_APP_OLD_FRONT_LINK || '',
  ga: process.env.REACT_APP_GA || '',
  gaBrand: process.env.REACT_APP_GA_BRAND || '',
  muiLicenseKey: process.env.REACT_APP_MUI_LICENSE_KEY || '',
  sentryDsn: process.env.REACT_APP_SENTRY_DSN || '',
  sentryEnabled: process.env.REACT_APP_SENTRY_ENABLED || 'false',
  agentModule: process.env.REACT_APP_AGENT_MODULE || 'false',
};
